/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { getSlugParam } from "@cosmos/next-common/dist/utils";
import { Metadata } from "next/types";

import { CosmosPageMetadata } from "../common/page.types";

export async function cosmosPageAuthMetadata({
	slug: rootSlug = "",
	params,
	getAppMetadata,
}: CosmosPageMetadata): Promise<Metadata> {
	const slugParam = getSlugParam(params);
	const slug = `${rootSlug}${slugParam}`;
	const locale = params.lang;

	return getAppMetadata({}, slug, locale);
}
